import { render, staticRenderFns } from "./ModalEditor.vue?vue&type=template&id=4008843f&scoped=true"
import script from "./ModalEditor.vue?vue&type=script&lang=js"
export * from "./ModalEditor.vue?vue&type=script&lang=js"
import style0 from "./ModalEditor.scss?vue&type=style&index=0&id=4008843f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008843f",
  null
  
)

export default component.exports